/**
 * Web mock for react-native-sound-player
 * Logs to console on web (no audio playback)
 */

export default {
  playUrl: (url) => {
    console.log('[FVrad] Alert sound (web mock):', url);
  },
  playSoundFile: (name, type) => {
    console.log('[FVrad] Alert sound (web mock):', name, type);
  },
};
